// 车辆管理
export default [
    {
      path: '/repairParts',
      name: 'repairParts',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/warehouseConfig/repairParts.vue'], resolve)
      }
    },
    {
      path: '/stockConfig',
      name: 'stockConfig',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/warehouseConfig/stockConfig.vue'], resolve)
      }
    }
  
  ]
  


// WEBPACK FOOTER //
// ./src/router/warehouseConfig.js